<template>
	<div class="code-wrapper">
		<div class="login-img" @click="$router.push('/')">
			<img src="@/assets/images/registerLogin.png" alt="">
		</div>
		<div class="image-container">
			<div class="conter-left">
				<div class="verification-title">验证您的电子邮件</div>
				<div class="verification-details">
					<div class="verification-subtitle">我们已将验证码发送到</div>
					<div v-if="backStr" class="verification-email">{{ backStr.submitForm.email }}</div>
				</div>
				<div class="verification-instructions">请检查您的收件箱并从下面输入验证码以验证您的电子邮件。</div>

				<div class="verification-code-container">
					<input class="numberbox" maxlength='6' v-model="code">
					<input disabled v-for="(digit, index) in 6" :key="index" :value="code[index] || ''"
						@input="handleInput(index)" @keydown.backspace="handleBackspace(index)" maxlength="1"
						:class="[code[index] ? 'active' : '', 'verification-code-input']" ref="inputElements" />
				</div>
				<button v-if="!checking"  @click="regEmail" class="custom-button">
					<span class="button-text">验证并继续</span>
				</button>
				<button v-if="checking" class="custom-button">
					<span   class="button-text">正在验证</span>
				</button>
				<div class="verification-error">找不到验证码？请检查您的垃圾邮件。</div>
				<div class="resend-code" @click="handleResendCode" :class="{ 'disabled': countdown > 0 }">
					{{ countdown > 0 ? countdownText : '重新获取验证码' }}
				</div>
			</div>
			<div class="image-wrapper">
				<img src="@/assets/images/register.png" alt="">
			</div>
		</div>
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
export default {
	data() {
		return {
			partner_id:'',
			code: [],
			codeStr: '',
			countdown: 60,
			backStr: {},
			email: '',
			checking:false
		}
	},
	computed: {
		countdownText() {
			return `重发验证码（${this.countdown}s）`;
		},
	},
	created(option) {
		
		console.log(this.code)
		this.backStr = this.$getStorage('localdata')
		this.partner_id = this.$getStorage('partner_id')
		if(!this.partner_id){
			if (this.$route.query.partner_id) {
			    this.partner_id = this.$route.query.partner_id
				this.$setStorage('partner_id', this.partner_id)
			}
		}else{
			console.log('partner_id:',this.partner_id)
		}
		
	},
	methods: {
		handleInput(index) {
			console.log('index:',index)
			if (this.code[index].length === 1) {
				if (index < 5) {
					this.$refs.inputElements[index + 1].focus();
				}
			} else if (this.code[index].length === 0) {
				if (index > 0) {
					this.$refs.inputElements[index - 1].focus();
				}
			}
		},
		handleBackspace(index) {
			if (index > 0 && this.code[index].length === 0) {
				this.$refs.inputElements[index - 1].focus();
			}
		},
		handleResendCode() {
			if (this.countdown === 0) {
				// 启动倒计时，发送验证码
				this.code = []
				this.sendEmail()
				this.startCountdown();
			}
		},
		startCountdown() {
			this.countdown = 60;
			const timer = setInterval(() => {
				if (this.countdown > 0) {
					this.countdown--;
				} else {
					clearInterval(timer);
				}
			}, 1000);
		},
		async regEmail() {
			if(this.checking){
				console.log('checking... can not do this ')
				return
			}


			this.codeStr = this.code[0] + this.code[1] + this.code[2] + this.code[3] + this.code[4] + this.code[5]
			console.log(this.codeStr)
			if(this.codeStr.length != 6){
				console.log('checking... can not do this1 ')
				return
			}
			let fdata = {
				do: 'Register',
				email: this.backStr.submitForm.email,
				password: this.backStr.submitForm.password,
				contact: this.backStr.submitForm.mobile,
				registerRef: this.backStr.registerRef,
				code: this.codeStr,
				partner_id:this.partner_id
			}

			this.checking = true 
			let res = await this.$api.funk(fdata)

			if (res.retDescr == 'Success') {
				console.log('reg ok ');
				this.$message.success('注册成功！');
				this.checking = false
				this.$router.push({ path: '/selectionCriteria' })
			} else {
				this.code = [];
				this.checking = false
				this.$message.error(res.retDescr);
			}
		},
		async sendEmail() {

			let fdata = { do: 'Send_email_otp', email: this.backStr.submitForm.email }
			let res = await this.$api.funk(fdata)
			if (res.retDescr == 'Success') {
				this.backStr.registerRef = res.registerRef

				this.code = [];
				this.countdown = 60
				console.log('send email to:' + this.backStr.submitForm.email);

				//this.$router.push({ path: '/code' })
			} else {
				console.log('error send email ');
			}
		},
	},
	mounted() {
		
		this.inputElements = this.$refs.inputElements;
		this.startCountdown()
	}
}
</script>

<style lang="scss" scoped>
.code-wrapper {
	padding: 0.24rem 0.24rem 0.24rem 0.4rem;

	/* Add the following media query for mobile devices */
	@media (max-width: 768px) {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100vh;
	}

	.login-img {
		position: absolute;
		left: 0;
		top: 0;
		cursor: pointer;

		img {
			margin-top: 0.16rem;
			margin-left: 0.40rem;
			width: 1.04rem;
			height: 0.48rem;
			display: block;
		}

	}

	.image-container {
		display: flex;
		justify-content: space-between;

		.conter-left {
			margin-right: 3.02rem;
			padding-top: 1.80rem;

			@media (max-width: 768px) {
				margin-right: 0;
				margin-top: 0.40rem;
				padding-top: 0rem;

			}

			.verification-title {
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 600;
				font-size: 0.40rem;
				line-height: 0.56rem;
				/* identical to box height */
				color: #000000;
			}

			.verification-details {
				display: flex;
				padding-top: 0.24rem;

				.verification-subtitle {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 400;
					font-size: 0.26rem;
					line-height: 0.28rem;
					color: #000000;
				}

				.verification-email {
					padding-left: 0.08rem;
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 400;
					font-size: 0.26rem;
					line-height: 0.28rem;
					color: #E02E43;
				}
			}

			.verification-instructions {
				padding-top: 0.08rem;
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 400;
				font-size: 0.26rem;
				line-height: 0.28rem;
				color: #666666;
			}

			.custom-button {
				margin-top: 0.80rem;
				width: 100%;
				background: #E02E43;
				border-radius: 0.08rem;
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 0.24rem;
			}

			.verification-error {
				margin-top: 0.24rem;
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 400;
				font-size: 0.26rem;
				line-height: 0.28rem;
				color: #666666;
			}

			.resend-code {
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 400;
				font-size: 0.26rem;
				line-height: 0.28rem;
				text-decoration-line: underline;
				color: #E02E43;
				cursor: pointer;
				padding-top: 0.08rem;
			}

			.resend-code.disabled {
				pointer-events: none;
				opacity: 0.5;
			}

			.button-text {
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 600;
				font-size: 0.24rem;
				line-height: 0.32rem;
				color: #FFFFFF;
				cursor: pointer;
			}


			.verification-code-container {
				display: flex;
				justify-content: center;
				margin-top: 0.8rem;
				position: relative;
				height: 0.56rem;

				.numberbox {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					opacity: 0;
					font-size: 0.24rem;
					z-index: 100;
				}

				&>*:not(:first-child) {
					margin-left: 20px;
				}

				.verification-code-input {
					width: 1.16rem;
					height: 0.56rem;
					// margin: 0 10px;
					padding: 0;
					text-align: center;
					font-size: 0.24rem;
					opacity: 0.5;
					border: 2px solid #000000;
					border-radius: 0.04rem;

					&.active {
						border-color: #E02E43;
					}
				}

				.verification-code-input:focus {
					outline: none;
				}
			}
		}

		.image-wrapper {
			width: 7.76rem;
			border-radius: 0.3rem;
			overflow: hidden;

			/* Add the following styles for mobile devices */
			@media (max-width: 768px) {
				display: none;
			}
		}

		.image-wrapper img {
			width: 100%;
			object-fit: cover;
			display: block;
		}
	}
}

@media (max-width: 750px) {
	.code-wrapper .login-img {
		left: 0.4rem;
		top: 0.4rem;
	}

	.code-wrapper .login-img img {
		height: 0.8rem;
		width: inherit;
		margin: 0;

	}

	.code-wrapper {
		padding: 0.4rem;
		display: block;
	}

	.code-wrapper .image-container {
		height: auto;
		margin: 0;
		display: block;
		margin-top: 2rem;
	}

	.code-wrapper .image-container .conter-left .verification-details .verification-subtitle,
	.code-wrapper .image-container .conter-left .verification-instructions {
		font-size: 0.24rem;
		line-height: 0.26rem;
	}

	.code-wrapper .image-container .conter-left .verification-code-container {
		justify-content: space-between;
		height: 0.8rem;
	}

	.code-wrapper .image-container .conter-left .verification-code-container .verification-code-input {
		width: 1rem;
		height: 0.8rem;
		margin: 0;
	}

	.code-wrapper .image-container .conter-left .custom-button {
		margin-top: 0.8rem;
		width: 100%;
		background: #E02E43;
		border-radius: 0.08rem;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0.46rem 0;
		border-radius: 0.14rem;

	}

	.code-wrapper .image-container .conter-left .button-text {
		font-size: 0.4rem;
		line-height: 0.4rem;
	}

	.code-wrapper .image-container .conter-left .verification-error {
		margin-top: 0.4rem;
		font-size: 0.24rem;
		line-height: 0.26rem;
	}

	.code-wrapper .image-container .conter-left .resend-code {
		font-size: 0.24rem;
		line-height: 0.26rem;
		margin-top: 0.1rem;
	}
}
</style>
<template>
	<div class="adivice-wrapper">
		<div class="reservation-wrapper">
			<div class=" flex-bt">
				<div class="left">
					<div class="title flex-start">
						<div class="logo-wrapper">
							<img src="@/assets/images/small-logo.png" alt="" />
						</div>
						<span>开店有疑难？</span>
					</div>
					<div class="big-title">揾<span>专家</span>谈谈</div>
					<div class="tips">
						有任何关于开网店或电商难题，不妨预约谈谈， LOOPSHOP
						电商顾问会为你提供最适切的帮助。
					</div>
					<router-link to="/consultation">
						<div class="start" id="scrollButton">立即预约</div>
					</router-link>
				</div>
				<div class="right">
					<img src="@/assets/images/suitability3.png" alt="" />
				</div>
			</div>
		</div>
		<div class="reservation-grop-warpper" id="targetElement">
			<div class="reservation-flex">
				<div class="left">
					<img src="@/assets/images/advice1.png" alt="" />
				</div>
				<div class="right">
					<div class="reservation">
						<div>立即预约 <span>专人咨询</span></div>
					</div>
					<div class="form">

						<div class="form-group">
							<div class="label">您的名字</div>
							<input id="name" v-model="formData['nickname']" :class="{ error: showError == 'nickname' }"
								placeholder="您的名字" />
						</div>
						<div class="form-group">
							<div class="label">电话</div>
							<input id="phone" v-model="formData['mobile']" :class="{ error: showError == 'mobile' }"
								placeholder="您的电话" />
						</div>
						<!-- <div class="form-group">
							<div class="label">电话验证码</div>
							<div class="value">
								<input id="mobileCode" v-model="formData['mobileCode']"
									:class="{ error: showError && formData['mobileCode'] === '' }" placeholder="电话验证码" />
								<div class="code" @click="sendMobile()" :class="[mobileCode != '60' ? 'disabled' : '']">{{
									mobileCode == 60 ?
									'发送验证码' : `${mobileCode}S` }} </div>
							</div>
						</div> -->
						<div class="form-group">
							<div class="label">电邮</div>
							<input id="email" v-model="formData['email']" :class="{ error: showError == 'email' }"
								placeholder="您的电邮" />
						</div>
						<!-- <div class="form-group">
							<div class="label">电邮验证码</div>
							<div class="value">
								<input id="emailCode" v-model="formData['emailCode']"
									:class="{ error: showError && formData['emailCode'] === '' }" placeholder="电邮验证码" />
								<div class="code" :class="[emailCode != '60' ? 'disabled' : '']" @click="sendEmail()">{{
									emailCode == 60 ? '发送验证码'
									: `${emailCode}S`
								}} </div>
							</div>
						</div> -->
						<div class="form-group">
							<div class="label">您的网店或Facebook专页连结</div>
							<input id="link" v-model="formData['faceig']" :class="{ error: showError == 'faceig' }"
								placeholder="您的网店或Facebook专页连结" />
						</div>
						<div class="pay-attention">
							* 填妥表格登记，即代表同意所提供之资料可供LOOPSHOP日后作行销用途。
						</div>
						<div @click="submitForm" class="button">提交</div>
					</div>
				</div>
			</div>
		</div>
		<SwiperContent></SwiperContent>
		<Start></Start>
		<el-dialog title="提示" top="20%" :show-close="false" :visible.sync="dialogVisible" width="30%">
			<span>{{ timer }}秒后将为你链接专属客服</span>
		</el-dialog>
	</div>
</template>
<script>

import Start from "@/components/Start.vue";
import SwiperContent from "@/components/SwiperContent.vue";
import { checkFormToast, rules } from 'lonjin-helper'
export default {
	components: { SwiperContent, Start },
	data() {
		return {
			webset: [],
			mobileCode: 60,
			emailCode: 60,
			timer: 3,
			timerFun: null,
			dialogVisible: false,
			showError: false,
			formData: {
				nickname: '',
				mobile: '',
				email: '',
				faceig: '',
				sjk: 'consultation'
			},

		};
	},

	mounted() {
		const scrollButton = document.getElementById('scrollButton');
		const targetElement = document.getElementById('targetElement');

		// 添加点击事件监听器
		scrollButton.addEventListener('click', () => {
			// 将目标元素滚动到可视区域内
			targetElement.scrollIntoView({ behavior: 'smooth' });
		});
	},
	created() {
		this.getSet()
	},
	methods: {

		sendMobile() {
			if (this.mobileCode < 60) return false
			const _this = this
			let timer = setInterval(() => {
				_this.mobileCode -= 1
				if (_this.mobileCode <= 0) {
					_this.mobileCode = 60
					clearInterval(timer)
				}
			}, 1000)
		},

		sendEmail() {
			if (this.emailCode < 60) return false
			const _this = this
			let timer = setInterval((val) => {
				_this.emailCode -= 1
				if (_this.emailCode <= 0) {
					_this.emailCode = 60
					clearInterval(timer)
				}
			}, 1000)
		},
		handleClose() {
			clearInterval(this.timerFun)
			this.dialogVisible = false
		},

		openTimer() {
			!this.dialogVisible && (this.dialogVisible = true)
			this.timerFun = setInterval(() => {
				if (this.timer == 1) {
					clearInterval(this.timerFun)
					this.dialogVisible = false
					let gourl = 'https://api.whatsapp.com/send?phone=' + this.webset.whatsapp + '&msg=' + this.webset.sayhi
					window.location.href = gourl
				} else {
					this.timer--
				}
			}, 1000);
		},

		async getSet() {
			console.log('go...');
			let fdata = { do: 'getSet', goto: 'webset' }
			let res = await this.$api.funk(fdata)
			this.webset = res
		},

		async submitForm() {
			this.showError = '';
			const mobileRules = (val, message) => {
				const reg = /^\d{8}$/;
				if (!reg.test(val)) return message
			}
			let nickname = rules.isEmpty(this.formData.nickname, '请输入您的名字')
			let mobile = rules.isEmpty(this.formData.mobile, '请输入电话')
			let isMobile = mobileRules(this.formData.mobile, '请输入8位电话号码')
			let email = rules.isEmpty(this.formData.email, '请输入电邮')
			let isEmail = rules.isEmail(this.formData.email, '请输入正确的电邮')
			let faceig = rules.isEmpty(this.formData.faceig, '请输入您的网店或Facebook专页连结')
			let message = checkFormToast(nickname, mobile, isMobile, email, isEmail, faceig)


			const MESSAGE_ENUM = {
				'请输入您的名字': 'nickname',
				'请输入电话': 'mobile',
				'请输入8位电话号码': 'mobile',
				'请输入电邮': 'email',
				'请输入正确的电邮': 'email',
			}

			if (message) {
				this.showError = MESSAGE_ENUM[message]
				this.$message.error(message)
			} else {
				// 执行报名逻辑
				console.log('报名成功');
				let res = await this.$api.register(this.formData)
				if (res.code == 1) {
					this.$message.success('OK');
					this.openTimer()

				} else {
					this.$message.error('error');
				}
			}
		},
	}
};
</script>
<style lang="scss" scoped>
.adivice-wrapper {
	.error {
		border: 1px solid red !important;
	}

	.reservation-wrapper {
		.left {
			padding-left: 3.2rem;

			.tips {
				text-align: left;
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 400;
				font-size: 0.24rem;
				line-height: 0.34rem;
				color: #000000;
				width: 4rem;
			}

			.big-title {
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 600;
				font-size: 0.56rem;
				line-height: 0.78rem;
				color: #000000;

				span {
					color: #e02e43;
				}
			}

			.start {
				width: 2.72rem;
				height: 0.8rem;
				background: #e02e43;
				border-radius: 0.08rem;
				margin-top: 0.8rem;
				cursor: pointer;
				text-align: center;
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 600;
				font-size: 0.24rem;
				line-height: 0.8rem;
				color: #ffffff;
				letter-spacing: 1px;
			}

			.title {
				position: relative;

				.logo-wrapper {
					position: absolute;
					bottom: 0.4rem;
					left: -0.4rem;
					width: 0.78rem;
					height: 0.49rem;

					img {
						width: 100%;
						height: 100%;
						display: block;
					}
				}

				span {
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 600;
					font-size: 0.57rem;
					line-height: 0.48rem;
					color: #000000;
				}

				.tag {
					width: 1.18rem;
					height: 0.54rem;
					background: #e02e43;
					border-radius: 0.04rem;
					text-align: center;
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 600;
					font-size: 0.32rem;
					line-height: 0.54rem;
					color: #ffffff;
					margin-left: 0.08rem;
				}
			}
		}

		.right {
			width: 10.50rem;
			height: 8.8rem;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}
		}
	}

	.reservation-grop-warpper {
		.reservation-flex {
			display: flex;

			.left {
				width: 8.70rem;
				height: 8.8rem;

				img {
					width: 100%;
					height: 100%;
					display: block;
					object-fit: cover;
				}
			}

			.right {
				padding-left: 1.1rem;

				.reservation {
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 600;
					font-size: 0.4rem;
					line-height: 0.4rem;
					color: #000000;
					padding-top: 0.6rem;
					padding-bottom: 0.4rem;

					span {
						color: #e02e43;
					}
				}

				.form {
					.form-group {
						.label {
							font-family: "Microsoft YaHei";
							font-style: normal;
							font-weight: 400;
							font-size: 0.2rem;
							line-height: 0.28rem;
							color: #000000;
							margin-top: 0.16rem;
						}

						.value {
							width: 4.3rem;
							height: 0.56rem;
							background: #fafafa;
							border: 1px solid #999999;
							border-radius: 0.08rem;
							display: block;
							margin-top: 0.08rem;
							padding: 0 0.16rem;
							display: flex;
							justify-content: space-between;
							overflow: hidden;
							align-items: center;
							padding-right: 0;

							input {
								flex: 1;
								border: none;
								margin: 0;
								padding: 0;
							}

							.code {
								background: #e02e43;
								color: #fff;
								width: 1rem;
								height: 0.46rem;
								font-size: 12px;
								text-align: center;
								border-radius: 0.08rem;
								line-height: 0.46rem;
								cursor: pointer;
								margin-right: 0.04rem;

								&.disabled {
									background: #999999;
									cursor: not-allowed;
								}
							}
						}

						input {
							width: 4.3rem;
							height: 0.56rem;
							background: #fafafa;
							border: 1px solid #999999;
							border-radius: 0.08rem;
							display: block;
							margin-top: 0.08rem;
							padding: 0 0.16rem;
						}

						input::placeholder {
							font-family: "Nunito";
							font-style: normal;
							font-weight: 400;
							font-size: 0.16rem;
							line-height: 0.24rem;
							letter-spacing: 0.5px;
							color: #1c1b1f;
						}
					}

					.pay-attention {
						font-family: "Microsoft YaHei";
						font-style: normal;
						font-weight: 400;
						font-size: 0.12rem;
						line-height: 0.17rem;
						color: #000000;
						margin-top: 0.16rem;
					}

					.button {
						width: 2.08rem;
						font-family: "Microsoft YaHei";
						font-style: normal;
						font-weight: 600;
						font-size: 0.24rem;
						line-height: 0.32rem;
						color: #ffffff;
						padding: 0.16rem 0;
						text-align: center;
						background: #e02e43;
						border-radius: 0.08rem;
						margin-top: 0.4rem;
						cursor: pointer;
					}
				}
			}
		}

	}
}

@media (max-width: 750px) {
	.reservation-wrapper .flex-bt {
		display: block;
	}

	.adivice-wrapper .reservation-wrapper .left {
		padding: 1.6rem 0.4rem 0.8rem 0.8rem;
	}

	.adivice-wrapper .reservation-wrapper .left .tips {
		width: 100%;
		font-size: 0.28rem;
		line-height: 0.34rem;
	}

	.adivice-wrapper .reservation-wrapper .left .big-title {
		margin-top: 0.12rem;
	}

	.adivice-wrapper .reservation-wrapper .left .start {
		width: 3.72rem;
		height: 1.1rem;
		line-height: 1.1rem;
		border-radius: 0.1rem;
		font-size: 0.3rem;
	}

	.adivice-wrapper .reservation-wrapper .right {
		width: 100%;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex {
		display: block;
	}

	.reservation-grop-warpper {
		height: 20.8rem;
		position: relative;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .left {
		width: 100%;
		position: absolute;
		top: 12rem;
		left: 0;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right {
		padding-left: 0.4rem;
		padding-right: 0.4rem;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right .reservation {
		font-size: 0.5rem;
		line-height: 0.5rem;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right .form .form-group .label {
		font-size: 0.32rem;
		margin-top: 0.32rem;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right .form .pay-attention {
		font-size: 0.2rem;
		line-height: 0.3rem;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right .form .form-group input {
		width: 100%;
		height: 0.9rem;
		margin-top: 0.12rem;
		font-size: 0.32rem;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right .form .button {
		width: 3.4rem;
		font-size: 0.32rem;
		line-height: 0.32rem;
		padding: 0.3rem 0;
		border-radius: 0.1rem;
	}
}
</style>